import React from 'react';
import {FormattedMessage} from 'react-intl';

const SurveyEditorBox = ({title, children}) => (
    <div className="survey-editor-box">
        {title && (
            <label className="col-form-label survey-editor-box-title">
                <FormattedMessage {...title} />
            </label>
        )}
        <div className="survey-editor-box-body">
            {children}
        </div>
    </div>
);

export default SurveyEditorBox;
